<script setup lang="ts">
/**
 * The analytics question (lib/consent.ts). Both answers are the same size and
 * weight: a "no" that is harder to give than a "yes" is not consent.
 */
import { analyticsConsent, consentBannerOpen, setAnalyticsConsent } from '@/lib/consent';
</script>

<template>
  <section
    v-if="consentBannerOpen"
    role="region"
    :aria-label="$t('consent.title')"
    class="fixed inset-x-0 bottom-0 z-50 px-4 pb-4 sm:px-8"
  >
    <div
      class="mx-auto flex max-w-3xl flex-wrap items-center gap-4 rounded-2xl border border-line bg-surface p-5 text-ink shadow-lg"
    >
      <div class="min-w-0 flex-[1_1_320px]">
        <h2 class="font-bold">{{ $t('consent.title') }}</h2>
        <p class="mt-1 text-sm text-muted">{{ $t('consent.body') }}</p>
        <p v-if="analyticsConsent" class="mt-1 text-sm text-muted">
          {{ $t(`consent.current.${analyticsConsent}`) }}
        </p>
      </div>
      <div class="flex flex-[0_0_auto] gap-2">
        <button
          type="button"
          class="min-h-11 rounded-xl border border-ink px-4 font-semibold"
          @click="setAnalyticsConsent('denied')"
        >
          {{ $t('consent.deny') }}
        </button>
        <button
          type="button"
          class="min-h-11 rounded-xl border border-ink bg-ink px-4 font-semibold text-page"
          @click="setAnalyticsConsent('granted')"
        >
          {{ $t('consent.allow') }}
        </button>
      </div>
    </div>
  </section>
</template>
